<script lang="ts">
  import Search from '$shared/atoms/Search/Search.svelte';
  import SearchItem from './partials/SearchItem.svelte';
  import type SearchProvider from '$provider/models/SearchProvider';

  interface Props {
    searchResult?: SearchProvider[];
    searchLoading?: boolean;
    searchPlaceholder?: string | null;
    action?: import('svelte').Snippet;
    onsearch?: (searchKey: string) => void;
    onclicksearchresult?: (result: SearchProvider) => void;
    onclearsearchresult?: () => void;
  }

  let {
    searchResult = [],
    searchLoading = false,
    searchPlaceholder = null,
    action,
    onsearch,
    onclicksearchresult,
    onclearsearchresult
  }: Props = $props();

  let searchInput: Search;
  let searchParent: HTMLDivElement;
  let searchValue = $state('');

  const resetSearch = () => {
    searchValue = '';
    if (searchInput) searchInput.reset();
  };

  const onSearchChange = (searchKey: string) => {
    searchValue = searchKey;
    onsearch?.(searchKey);
  };

  const onClickSearchResult = (result: SearchProvider): void => {
    resetSearch();
    onclicksearchresult?.(result);
  };

  const handleMouseClick = (e: any): void => {
    if (searchParent && !searchParent.contains(e.target)) {
      resetSearch();
      onclearsearchresult?.();
    }
  };

  let noResult = $derived(searchValue && searchResult.length === 0);
  let searchList = $derived((searchValue && searchResult) || []);
</script>

<svelte:window onmouseup={handleMouseClick} />

<div class="comp-main-actions">
  <div bind:this={searchParent} class="action search">
    <Search
      bind:this={searchInput}
      minLength={3}
      placeholder={searchPlaceholder}
      loading={searchLoading}
      onchange={onSearchChange}
      name="global-search"
    />
    {#if !searchLoading}
      <div class="search-list" data-cy="search-list">
        {#if noResult}
          <div class="no-result">No results found</div>
        {:else}
          {#each searchList as result}
            <SearchItem
              {result}
              onclick={() => {
                onClickSearchResult(result);
              }}
            />
          {/each}
        {/if}
      </div>
    {/if}
  </div>
  {#if action}
    <div class="action">
      {@render action?.()}
    </div>
  {/if}
</div>

<style src="./MainActions.css">
</style>
